// pages/CheckEmail.jsx
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "../PageLayout/LoginLayout";
import { requestPasswordReset } from "../services/auth.service";

export default function CheckEmail() {
  const location = useLocation();
  const navigate = useNavigate();

  // Extract email & token from query params or state
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token") || location.state?.token || "";
  const email = queryParams.get("email") || location.state?.email || "";

  // Redirect if no email
  useEffect(() => {
    if (!email) navigate("/forgot-password");
  }, [email, navigate]);

  const [timer, setTimer] = useState(188);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    let interval = null;
    if (isActive && timer > 0) {
      interval = setInterval(() => setTimer((t) => t - 1), 1000);
    }
    return () => clearInterval(interval);
  }, [isActive, timer]);

  const handleResend = async () => {
    try {
      await requestPasswordReset(email);
      setTimer(188);
      setIsActive(true);
    } catch (err) {
      const msg = err?.response?.data?.message || err.message || "Failed to send email";
      alert(msg);
    }
  };

  const handleContinue = () => {
    if (!token) {
      alert("Token not found. Please check your email link.");
      return;
    }
    navigate(`/create-new-password?token=${token}&email=${encodeURIComponent(email)}`);
  };

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };

  return (
    <Layout>
      <div className="w-full max-w-md mx-auto px-6 py-12">
        <Link
          to="/forgot-password"
          className="text-sm text-gray-500 hover:underline mb-6 inline-block"
        >
          &larr; Back
        </Link>

        <h1 className="text-xl font-semibold mb-2">Check your email</h1>
        <p className="text-sm text-gray-500 mb-6 leading-relaxed">
          We have sent the password reset link to{" "}
          <span className="font-medium text-gray-700">{email}</span>. Please
          check your inbox or spam folder.
        </p>

        <button
          onClick={handleResend}
          disabled={timer > 0}
          className={`w-full py-2 px-4 rounded-md text-white font-medium ${
            timer > 0
              ? "bg-[#1E1E2F] opacity-80 cursor-not-allowed"
              : "bg-[#1E1E2F] hover:bg-[#1E1E2F]"
          }`}
        >
          {timer > 0
            ? `Send Again (${formatTime(timer)})`
            : "Send Again"}
        </button>

        {token && (
          <button
            onClick={handleContinue}
            className="w-full mt-4 py-2 px-4 rounded-md text-white font-medium bg-blue-600 hover:bg-blue-500"
          >
            Continue to Create New Password
          </button>
        )}

        <p className="text-xs text-gray-500 mt-4">
          Are you having problems?{" "}
          <Link to="/contact" className="hover:underline">
            Contact us
          </Link>
        </p>
      </div>
    </Layout>
  );
}
